var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#E30600"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 22.94C10 28.47 13.01 34 19.66 34C26.31 34 29.32 28.47 29.32 22.94C29.32 19.16 28.06 14.82 26.03 11.39C24.07 8.03 21.69 6 19.66 6C17.63 6 15.25 8.03 13.29 11.39C11.26 14.89 10 19.23 10 22.94Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMts);
export default __webpack_public_path__ + "static/media/mts.8b69e1fb79646d33f355da4379e01d78.svg";
export { ForwardRef as ReactComponent };